if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[name="locale_code"], input[name="country_code"]');
        this.trigger = this.querySelector('button.localization-form__select');
        this.countryDialog = this.querySelector('[data-country-dialog]');
        this.header = document.querySelector('.header-wrapper');
        this.lastActiveElement = null;

        if (!this.form || !this.input || !this.trigger) return;
        if (this.countryDialog) {
          this.initCountrySelector();
        } else {
          this.initDisclosureSelector();
        }
      }

      initDisclosureSelector() {
        this.panel = this.querySelector('.disclosure__list-wrapper');
        if (!this.panel) return;
        this.trigger.addEventListener('click', () => this.toggleDisclosure());
        this.querySelectorAll('a[data-value]').forEach((item) => {
          item.addEventListener('click', (event) => {
            event.preventDefault();
            this.input.value = event.currentTarget.dataset.value;
            this.form.requestSubmit();
          });
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !this.panel.hidden) {
            this.closeDisclosure();
            this.trigger.focus();
          }
        });
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.closeDisclosure();
        });
      }

      toggleDisclosure() {
        const willOpen = this.panel.hidden;
        this.panel.hidden = !willOpen;
        this.trigger.setAttribute('aria-expanded', String(willOpen));
      }

      closeDisclosure() {
        this.panel.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');
      }

      initCountrySelector() {
        this.modal = this.querySelector('[data-country-modal]');
        this.options = Array.from(this.querySelectorAll('[data-country-option]'));
        this.search = this.querySelector('[data-country-search]');
        this.status = this.querySelector('[data-country-status]');
        this.summary = this.querySelector('[data-country-summary]');
        this.saveButton = this.querySelector('[data-country-save]');
        this.committedValue = this.input.value;
        this.pendingValue = this.committedValue;

        this.trigger.addEventListener('click', () => this.openCountrySelector());
        this.querySelectorAll('[data-country-cancel]').forEach((button) => {
          button.addEventListener('click', () => this.closeCountrySelector());
        });
        this.options.forEach((option) => {
          option.addEventListener('click', () => {
            this.pendingValue = option.dataset.value;
            this.updatePendingSelection();
          });
        });
        this.search?.addEventListener('input', () => this.filterCountries());
        this.saveButton.addEventListener('click', () => {
          this.input.value = this.pendingValue;
          this.form.requestSubmit();
        });
        this.modal.addEventListener('keydown', (event) => this.trapFocus(event));
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !this.modal.hidden) this.closeCountrySelector();
        });
      }

      openCountrySelector() {
        this.lastActiveElement = document.activeElement;
        this.pendingValue = this.committedValue;
        this.updatePendingSelection();
        this.modal.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('country-switcher-open');
        if (this.hasAttribute('data-prevent-hide') && this.header) this.header.preventHide = true;
        requestAnimationFrame(() => (this.search || this.options[0] || this.saveButton).focus());
      }

      closeCountrySelector() {
        this.pendingValue = this.committedValue;
        this.input.value = this.committedValue;
        if (this.search) {
          this.search.value = '';
          this.filterCountries();
        }
        this.updatePendingSelection();
        this.modal.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('country-switcher-open');
        if (this.header) this.header.preventHide = false;
        this.lastActiveElement?.focus();
      }

      updatePendingSelection() {
        const selected = this.options.find((option) => option.dataset.value === this.pendingValue) || this.options[0];
        this.options.forEach((option) => option.setAttribute('aria-current', String(option === selected)));
        if (selected && this.summary) {
          this.summary.textContent = `${selected.dataset.countryName} · ${selected.dataset.countryCurrency}`;
        }
        this.saveButton.disabled = this.pendingValue === this.committedValue;
      }

      filterCountries() {
        const query = this.normalizeString(this.search?.value || '');
        let visible = 0;
        this.options.forEach((option) => {
          const matches = this.normalizeString(option.dataset.countryName).includes(query);
          option.closest('li').hidden = !matches;
          if (matches) visible += 1;
        });
        if (this.status) this.status.textContent = `${visible} countries available`;
      }

      trapFocus(event) {
        if (event.key !== 'Tab' || this.modal.hidden) return;
        const focusable = Array.from(
          this.countryDialog.querySelectorAll('button:not([disabled]), input:not([disabled])')
        ).filter((element) => !element.closest('[hidden]') && element.offsetParent !== null);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      normalizeString(value) {
        return value.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
      }
    }
  );
}
